// import { Icon } from "@iconify/react";
import React from "react";
// import Button from "../Button";
import Spacing from "../Spacing";
import { Parallax } from "react-parallax";
import { useTranslation } from 'react-i18next';

export default function AboutStyle2({
  thumbnailSrc1,
  thumbnailSrc2,
  uperTitle,
  title,
  subTitle,
  subTitle1,
  subTitle2,
  subTitle3,
  // featureList,
  // btnText,
  // btnUrl,
}) {
  const { t, i18n } = useTranslation([]);
  const languageButton = i18n.language === 'en' ? 'he' : 'en';
  const isHebrew = languageButton === 'he';

  return (
    <div className="container">
      <div className={`row cs_gap_y_40 align-items-center  ${isHebrew ? '' : 'flex-row-reverse cs_gap_x_10'}`}>
        <div className="col-lg-6 text-right">
          <div className="cs_section_heading cs_style_1 "
            style={{ textAlign: "right", lineHeight: "30px" }}>
            <p className="cs_section_subtitle cs_undertext_color cs_fs_18 mb-0">
              {uperTitle}
            </p>
            <Spacing lg="10" md="5" />
            <h2 className="cs_section_title cs_fs_50 mb-0 font_title">
              {title}
            </h2>
            <Spacing lg="30" md="30" />
            <div className="font_futura">
              <p className="m-0 ">{subTitle}</p>
              <Spacing lg="30" md="30" />
              <p className="m-0">{subTitle1}</p>
              <Spacing lg="30" md="30" />
              <p className="m-0">{subTitle2}</p>
              <Spacing lg="30" md="30" />
              <p className="m-0">{subTitle3}</p>
            </div>
          </div>
          <Spacing lg="40" md="30" />
          {/* <ul className="cs_list cs_style_1 cs_primary_font cs_primary_color cs_semibold cs_mp0 cs_fs_21 text_right">
            {featureList?.map((item, index) => (
              <li key={index}>
                <i className="d-flex text_right">
                  <Icon icon="fa6-regular:circle-check" />
                </i>
                {item}
              </li>
            ))}
          </ul> */}
          <Spacing lg="40" md="30" />
          {/* <div className="text_right">
            <Button btnText={btnText} btnUrl={btnUrl} />
          </div> */}
        </div>
        <div className="col-lg-5 offset-lg-1">
          <div className="cs_img_card_3_wrap cs_parallax">
            <div className="row">
              <div className="col-6">
                <div className="cs_img_card cs_style_3 cs_radius_15 overflow-hidden">
                  <Parallax
                    bgImage={thumbnailSrc1}
                    bgImageAlt="Thumb"
                    strength={-100}
                    className="h-100"
                  ></Parallax>
                </div>
              </div>
              <div className="col-6">
                <div className="cs_img_card cs_style_3 cs_radius_15 overflow-hidden">
                  <Parallax
                    bgImage={thumbnailSrc2}
                    bgImageAlt="Thumb"
                    strength={100}
                    className="h-100"
                  ></Parallax>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
